import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { Card } from '../components/ui/Card';
const associations = [{
  name: 'Bullhead City/Mohave Valley Association of REALTORS®',
  email: 'support@BHCMVAOR.org',
  phone: '928-758-4808',
  fax: '888-412-4667',
  address: '841 Hancock Rd. Bullhead City, AZ 86442'
}, {
  name: 'Central Arizona Board of REALTORS®',
  email: 'admin@caaraz.com',
  phone: '928-474-1944',
  fax: '928-472-8016',
  address: '600 E. Highway 260 #12 Payson, AZ 85541'
}, {
  name: 'Green Valley/Sahuarita Association of REALTORS®',
  email: 'info@gvsar.com',
  phone: '520-648-0800',
  fax: '',
  address: '210 W Continental Rd. #244 Green Valley, AZ 85622'
}, {
  name: 'Kingman/Golden Valley Association of REALTORS®',
  email: 'AE@kgvar.com',
  phone: '928-692-3222',
  fax: '928-692-3224',
  address: '1923 Kino Ave. Kingman, AZ 86409-3063'
}, {
  name: 'Lake Havasu Association of REALTORS®',
  email: 'Emily@havasurealtors.com',
  phone: '928-855-8423',
  fax: '928-855-5255',
  address: '2293 Swanson Ave. Lake Havasu City, AZ 86403'
}, {
  name: 'Northern Arizona Association of REALTORS®',
  email: 'naarflag@nazrealtor.com',
  phone: '928-779-4303',
  fax: '928-774-3230',
  address: '1515 E. Cedar Ave., Ste. C-4 Flagstaff, AZ 86004'
}, {
  name: 'Phoenix REALTORS®',
  email: 'membership@PhoenixRealtors.com',
  phone: '602-246-1012',
  fax: '602-246-1512',
  address: '7878 N 16th Street #150 Phoenix, AZ 85020'
}, {
  name: 'Prescott Area Association of REALTORS®',
  email: 'education@paar.org',
  phone: '928-445-2663',
  fax: '',
  address: '3719 Karicio Lane Prescott, AZ 86303-6829'
}, {
  name: 'Santa Cruz County Board of REALTORS®',
  email: 'education@weserv.realtor',
  phone: '520-377-9613',
  fax: '520-377-9614',
  address: 'PO Box 4875 Rio Rico, AZ 85648'
}, {
  name: 'Scottsdale Area Association of REALTORS® (SAAR)',
  email: 'info@scottsdalerealtors.org',
  phone: '480-945-2651',
  fax: '480-422-7945',
  address: '8600 E. Anderson Drive, Suite 200 Scottsdale, AZ 85255'
}, {
  name: 'Sedona/Verde Valley Association of REALTORS®',
  email: 'info@svvar.com',
  phone: '928-282-5409',
  fax: '928-282-3559',
  address: '859 Cove Parkway, Suite 102 Cottonwood, AZ 86326'
}, {
  name: 'Southeast Arizona Association of REALTORS®',
  email: 'education@weserv.realtor',
  phone: '520-458-7802',
  fax: '520-458-7620',
  address: '125 S. Second Street Sierra Vista, AZ 85635'
}, {
  name: 'Tucson Association of REALTORS®',
  email: 'education@tucsonrealtors.org',
  phone: '520-327-4218',
  fax: '520-322-6613',
  address: '2445 N. Tucson Blvd. Tucson, AZ 85716'
}, {
  name: 'WeSERV (West and Southeast REALTORS-includes Douglas and Pinal County)',
  email: 'Education@WeServ.realtor',
  phone: '480-477-5882',
  fax: '480-835-1329',
  address: '1733 E Northrop Blvd, Chandler, AZ 85286'
}, {
  name: 'White Mountain Association of REALTORS®',
  email: 'Michelle@wmaronline.com',
  phone: '928-537-1107',
  fax: '928-537-3788',
  address: '5658 Hwy. 260 Lakeside, AZ 85929'
}, {
  name: 'Yuma Association of REALTORS®',
  email: 'Angela@yumaaor.com',
  phone: '928-782-1628',
  fax: '928-782-7188',
  address: '74 W. 2nd St. Yuma, AZ 85364'
}];
export function ArizonaLocalAssociations() {
  return <div className="min-h-screen bg-gray-50 pt-40 lg:pt-52 pb-20" data-id="element-599">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-600">
        {/* Page Header */}
        <div className="mb-12" data-id="element-601">
          <h1 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-602">
            Arizona Local Associations
          </h1>
          <p className="text-lg text-gray-600" data-id="element-603">
            Contact information for Arizona REALTOR® associations. Email your
            NAR Code of Ethics & Fair Housing Certificates to the appropriate
            association.
          </p>
        </div>

        {/* Associations Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-604">
          {associations.map((association, index) => <Card key={index} className="p-6 hover:shadow-lg transition-shadow" data-id="element-605">
              <h2 className="text-xl font-bold text-brand-purple-900 mb-4" data-id="element-606">
                {association.name}
              </h2>

              <div className="space-y-3" data-id="element-607">
                {/* Email */}
                <div className="flex items-start" data-id="element-608">
                  <Mail className="w-5 h-5 text-brand-orange-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-609" />
                  <div data-id="element-610">
                    <p className="text-sm text-gray-600 mb-1" data-id="element-611">
                      Email your NAR Code of Ethics & Fair Housing Certificates
                      to:
                    </p>
                    <a href={`mailto:${association.email}`} className="text-brand-purple-600 hover:text-brand-purple-700 font-medium break-all" data-id="element-612">
                      {association.email}
                    </a>
                  </div>
                </div>

                {/* Phone */}
                <div className="flex items-center" data-id="element-613">
                  <Phone className="w-5 h-5 text-brand-orange-500 mr-3 flex-shrink-0" data-id="element-614" />
                  <div data-id="element-615">
                    <span className="text-sm text-gray-600 mr-2" data-id="element-616">Phone:</span>
                    <a href={`tel:${association.phone.replace(/[^0-9]/g, '')}`} className="text-gray-900 font-medium hover:text-brand-purple-600" data-id="element-617">
                      {association.phone}
                    </a>
                  </div>
                </div>

                {/* Fax */}
                {association.fax && <div className="flex items-center" data-id="element-618">
                    <div className="w-5 h-5 text-brand-orange-500 mr-3 flex-shrink-0" data-id="element-619" />
                    <div data-id="element-620">
                      <span className="text-sm text-gray-600 mr-2" data-id="element-621">Fax:</span>
                      <span className="text-gray-900 font-medium" data-id="element-622">
                        {association.fax}
                      </span>
                    </div>
                  </div>}

                {/* Address */}
                <div className="flex items-start" data-id="element-623">
                  <MapPin className="w-5 h-5 text-brand-orange-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-624" />
                  <div data-id="element-625">
                    <span className="text-sm text-gray-600 mr-2" data-id="element-626">Address:</span>
                    <address className="text-gray-900 not-italic" data-id="element-627">
                      {association.address}
                    </address>
                  </div>
                </div>
              </div>
            </Card>)}
        </div>

        {/* Help Section */}
        <div className="mt-12 bg-brand-purple-50 rounded-lg p-8 border border-brand-purple-100" data-id="element-628">
          <h3 className="text-xl font-bold text-brand-purple-900 mb-3" data-id="element-629">
            Need Help Finding Your Association?
          </h3>
          <p className="text-gray-700 mb-4" data-id="element-630">
            If you're unsure which association to contact, please reach out to
            us and we'll help you find the right one.
          </p>
          <a href="/Contact" className="inline-flex items-center px-6 py-3 bg-brand-purple-600 text-white font-bold rounded-md hover:bg-brand-purple-700 transition-colors" data-id="element-631">
            Contact Us
          </a>
        </div>
      </div>
    </div>;
}